import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { generateUrl } from 'data/utils';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { HandleActivitiesAnalyticalPerGroupUseCaseInterface } from 'domain/usecases';

export class RemoteHandleActivitiesAnalyticalPerGroup
  implements HandleActivitiesAnalyticalPerGroupUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<HandleActivitiesAnalyticalPerGroupUseCaseInterface.Result>,
  ) {}

  async execute(
    params: HandleActivitiesAnalyticalPerGroupUseCaseInterface.Params,
  ): Promise<HandleActivitiesAnalyticalPerGroupUseCaseInterface.Result> {
    const { responseType, ...restParams } = params;

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: generateUrl(`${this.url}${'/' + responseType}`, restParams),
      responseType: responseType === '2' ? 'json' : 'arraybuffer',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
